import { Box, Button, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  LoadingIndicator,
  TERMS_CONDITIONS_URL,
} from '@xolv-mybrightlink/common';
import { useOptInCommunity } from '../care-team/hooks/store/useCommunitySla';

export const CommunityOptInSlaStandalone = () => {
  const { loading, optInCommunity } = useOptInCommunity();
  if (loading) {
    return <LoadingIndicator />;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: 5,
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <Box
        className='hide-scrollbar'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
          alignItems: 'center',
          flex: 1,
          overflow: 'auto',
          pb: 14,
        }}
      >
        <img
          src='/public/assets/icons/ic_community.svg'
          width={60}
          height={60}
        />
        <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>
          <FormattedMessage id='community.setup-1.title' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-1.description' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-2.description' />
        </Typography>
        <Typography>
          <FormattedMessage id='community.setup-3.description' />
        </Typography>
        <Typography>
          <FormattedMessage
            id='community.setup-4.description'
            values={{
              tusLink: (text) => (
                <Link
                  rel='noopener'
                  variant='body1'
                  href={TERMS_CONDITIONS_URL}
                  target='_blank'
                >
                  {text}
                </Link>
              ),
            }}
          />
        </Typography>
      </Box>
      <Box
        sx={{
          pb: 10,
          position: 'relative',
          textAlign: 'center',
          width: '100%',
          '&:after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: -70,
            width: '100%',
            height: 70,
            background:
              'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, .7) 40%, #fff 70%)',
          },
        }}
      >
        <Button
          onClick={optInCommunity}
          disableElevation
          variant='contained'
          sx={{ px: 15, py: 4, borderRadius: 7.5 }}
        >
          <FormattedMessage id='actions.get-started' />
        </Button>
      </Box>
    </Box>
  );
};
